import styled from 'styled-components';
import { shouldIgnoreProp } from '../../../utils/shouldIgnoreProp';
import { Button } from '../../input/Button';
import { Flex } from '../../layout/Flex';
import { MediaCover } from '../../media/MediaCover';
import { Typography, TypographyProps } from '../../typography/Typography';
import {
    MEDIA_ITEM_OFFSET,
    PRODUCT_CONTAINER_WIDTH_INTENTION,
    PRODUCT_CONTENT_WIDTH_INTENTION,
    PRODUCT_TEXT_CONTAINER_WIDTH_INTENTION,
} from './constants';
import {
    ProductContainerProps,
    ProductMediaCoverProps,
    ProductMinizeButtonProps,
    ProductTextContainerProps,
} from './types';

export const MainButton = styled(Button)
    .withConfig({ displayName: 'MainButton' })
    .attrs((props) => ({
        ...props,
        as: 'a',
        target: '_blank',
        rel: 'nofollow noreferrer',
        flexGrow: 1,
        color: 'hardLight',
        backdropFilter: 'blur(25px)',
        width: '100%',
        height: '100%',
        borderRadius: 2,
        textTransform: 'none',
    }))``;

export const ProductMinizeButton = styled(Flex)
    .withConfig({
        displayName: 'ProductMinizeButton',
        shouldForwardProp: shouldIgnoreProp('isProductExpanded'),
    })
    .attrs((props) => ({
        ...props,
        alignItems: 'center',
        justifyContent: 'space-between',
        direction: 'row',
        textTransform: 'uppercase',
    }))<ProductMinizeButtonProps>`
    opacity: ${({ isProductExpanded }) => (isProductExpanded ? 0 : 1)};
`;

export const ProductContainer = styled(Flex)
    .withConfig({
        displayName: 'ProductContainer',
        shouldForwardProp: shouldIgnoreProp('isProductExpanded'),
    })
    .attrs((props) => ({
        ...props,
        width: `calc(100% - ${PRODUCT_CONTAINER_WIDTH_INTENTION}px)`,
        height: '100%',
        direction: 'row',
        overflow: 'hidden',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'absolute',
        left: 1,
    }))<ProductContainerProps>`
    opacity: ${({ isProductExpanded }) => (isProductExpanded ? 1 : 0)};
`;

export const ProductContent = styled(Flex)
    .withConfig({ displayName: 'ProductContent' })
    .attrs((props) => ({
        ...props,
        direction: 'row',
        alignItems: 'center',
        width: `calc(100% - ${PRODUCT_CONTENT_WIDTH_INTENTION}px)`,
    }))``;

export const ProductMediaCover = styled(MediaCover)
    .withConfig({
        displayName: 'ProductMediaCover',
        shouldForwardProp: shouldIgnoreProp('index'),
    })
    .attrs((props) => ({
        ...props,
        ratio: 1,
        height: props.height || 48,
        minWidth: props.minWidth || 48,
        width: props.width || 48,
        borderRadius: 1,
        position: 'relative',
        boxShadow: props.boxShadow || '2px 0px 4px 0px rgba(0, 0, 0, 0.15)',
    }))<ProductMediaCoverProps>`
    left: ${({ index = 0 }) => index && `-${MEDIA_ITEM_OFFSET * index}px`};
`;

export const ProductTextContainer = styled(Flex)
    .withConfig({
        displayName: 'ProductTextContainer',
        shouldForwardProp: shouldIgnoreProp('indexOffset'),
    })
    .attrs((props) => ({
        ...props,
        ml: 1,
        justifyContent: 'space-between',
        position: 'relative',
        maxWidth: `calc(100% - ${PRODUCT_TEXT_CONTAINER_WIDTH_INTENTION}px)`,
    }))<ProductTextContainerProps>`
    left: ${({ indexOffset = 0 }) => indexOffset && `-${MEDIA_ITEM_OFFSET * indexOffset}px`};
`;

export const ProductTitle = styled(Typography)
    .withConfig({ displayName: 'ProductTitle' })
    .attrs((props: TypographyProps) => ({
        ...props,
        weight: props.weight || 'regular',
        variant: 'caption',
        color: 'black',
        overflow: 'hidden',
        width: '100%',
        textTransform: 'none',
        textAlign: 'left',
    }))`
    text-overflow: ellipsis;
    white-space: nowrap;
`;
